import React from 'react'
import PropTypes from 'prop-types'
import { StatusHint } from 'evergreen-draft'
import { Pane, majorScale } from 'evergreen-ui'
import SearchResultRow from './SearchResultRow'
import SearchResultImage from './SearchResultImage'
import SearchResultTitle from './SearchResultTitle'

const getSubtitle = ({ item, category }) => {
  if (category === 'destination') {
    return `Receiving from ${item.source.slug}`
  }

  if (category === 'source' || category === 'warehouse') {
    return item.instanceName
  }
}

const SearchResult = ({
  isSelected,
  item,
  category,
  hasTopBorder,
  searchIndex,
  onClick
}) => (
  <SearchResultRow
    isSelected={isSelected}
    hasTopBorder={hasTopBorder}
    url={item.path}
    onClick={() => onClick(category, searchIndex, item)}
  >
    <Pane
      display="flex"
      alignItems="center"
      flex="1"
      minWidth={0}
      marginRight={majorScale(1)}
    >
      <SearchResultImage url={item.logo} />
      <SearchResultTitle
        title={item.name}
        subtitle={getSubtitle({ item, category })}
      />
    </Pane>

    {['destination', 'source', 'warehouse'].includes(category) && (
      <StatusHint
        isDisabled={!item.enabled}
        intent={item.enabled ? 'success' : 'none'}
        size={300}
      >
        {item.enabled ? 'Enabled' : 'Disabled'}
      </StatusHint>
    )}
  </SearchResultRow>
)

SearchResult.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  item: PropTypes.object,
  category: PropTypes.string,
  hasTopBorder: PropTypes.bool,
  searchIndex: PropTypes.number,
  onClick: PropTypes.func
}

SearchResult.defaultProps = {
  hasTopBorder: false
}

export default SearchResult
